import { Flex, Skeleton } from "@radix-ui/themes";
import { observer } from "mobx-react-lite";
import { forwardRef } from "react";

import { TOKEN_METADATA_BY_SYMBOL } from "@constants/metadata";
import { useStores } from "@stores";

import { Icon } from "@components/Icon";

import { MarginBadgeContainer, MarginBadgeText, MarketSelectButton, TokenIcon, TokenSymbolText } from "./styles";

// Only subscribes to stable values - no allMarkets (would re-render on every ticker update)
export const MarketSelectTrigger = observer(
  forwardRef<HTMLButtonElement, { onClick?: () => void }>(({ onClick }, ref) => {
    const { marketStore } = useStores();

    // Stable computed - only changes when market changes
    const symbol = marketStore.activeMarketSymbol;
    const baseSymbol = symbol ? symbol.split("-")[0] : undefined;

    // Static lookup - no observable
    const tokenMeta = baseSymbol ? TOKEN_METADATA_BY_SYMBOL[baseSymbol] : undefined;

    // instrumentInfo is from Map - updated only on instrument load, not on tickers
    const instrumentInfo = marketStore.getInstrumentInfo(symbol || "");
    const leverage = instrumentInfo?.leverage_filter?.max_leverage ?? "—";

    return (
      <MarketSelectButton data-testid="market-select:trigger" ref={ref} onClick={onClick}>
        <Skeleton loading={!symbol} width="150px">
          <Flex align="center" gap="8px">
            {tokenMeta?.icon && <TokenIcon alt={baseSymbol ?? ""} src={tokenMeta.icon} />}
            <Flex align="center" gap="2px">
              <TokenSymbolText>{baseSymbol}</TokenSymbolText>
              <MarginBadgeContainer>
                <MarginBadgeText>{leverage === "—" ? "—" : `${leverage}x`}</MarginBadgeText>
              </MarginBadgeContainer>
            </Flex>
            <Icon icon="ri-expand-up-down-line" />
          </Flex>
        </Skeleton>
      </MarketSelectButton>
    );
  }),
);

MarketSelectTrigger.displayName = "MarketSelectTrigger";
